import { render, staticRenderFns } from "./v-navbar-navigation.vue?vue&type=template&id=48c7556e&scoped=true&"
var script = {}
import style0 from "./v-navbar-navigation.vue?vue&type=style&index=0&id=48c7556e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c7556e",
  null
  
)

export default component.exports